const topbar = {
    docs: 'Documentação',
    help: 'Ajuda',
    subscription: 'Inscrição',
};
export default Object.freeze(topbar);
